import { SurveyState } from "./enums/survey-enums";

/**
 * Maps the state of a survey to a corresponding color.
 * @param state The state of the survey.
 * @returns The color associated with the state.
 */
export const stateColorMap = (state: string) => {
  switch (state) {
    case SurveyState.LIVE:
      return "green";
    case SurveyState.CLOSED:
      return "blue";
    case SurveyState.DRAFT:
      return "gray";
    default:
      return "";
  }
};
export function capitalize<T extends string>(word: T): T {
  if (!word) return word;
  return (word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) as T;
}
export function debounce<T extends (...args: unknown[]) => void>(
  func: T,
  delay: number,
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
}
